import router from './router'
import useMoreStore from './store'
import MoreMessages from './localization'

export default {
  router,
  useMoreStore,
  localization: MoreMessages,
}
